import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { AlertDialogConfig, DialogResult } from '../../../interfaces/dialog.interface';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
  standalone: true,
  imports: [NgClass, MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertDialogComponent {
  readonly data = inject<AlertDialogConfig>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<AlertDialogComponent>);

  passwordVisible = signal(false);
  copied = signal(false);

  constructor() {
    if (!this.data.confirmText) {
      this.data.confirmText = 'Aceptar';
    }
    if (!this.data.icon) {
      switch (this.data.type) {
        case 'error':
          this.data.icon = 'error';
          break;
        case 'warning':
          this.data.icon = 'warning';
          break;
        case 'success':
          this.data.icon = 'check_circle';
          break;
        case 'info':
        default:
          this.data.icon = 'info';
          break;
      }
    }
  }

  onConfirm(): void {
    const result: DialogResult = { confirmed: true };
    this.dialogRef.close(result);
  }

  togglePasswordVisibility(): void {
    this.passwordVisible.update(v => !v);
  }

  getMaskedText(): string {
    return '•'.repeat(this.data.copyableText?.length || 0);
  }

  copyToClipboard(): void {
    if (this.data.copyableText) {
      navigator.clipboard.writeText(this.data.copyableText).then(() => {
        this.copied.set(true);
        setTimeout(() => {
          this.copied.set(false);
        }, 2000);
      });
    }
  }
}
